/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

export { CurateSearchModule } from './curate-search.module';
export { CurateSearchComponent } from './curate-search.component';